import {ApiHelper, EnumParser} from "./base";

export const AdminPermissionsMask = {
    none: 0,
    admin: 1 << 0
};

export class AdminApi
{
    static async GetPermissionsAsync()
    {
        const params = new URLSearchParams({});

        const url = `api/get-permissions?${params.toString()}`;

        const result = await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'GET'
        });

        if (result.permissions)
        {
            return EnumParser.Parse(result.permissions, AdminPermissionsMask);
        }

        return AdminPermissionsMask.none;
    }

    static async GetGlobalMultipliersAsync()
    {
        return await ApiHelper.FetchJsonAndProcessErrorsAsync('api/server/admin-action/global-multipliers', {
            method: 'GET',
            cache: 'no-store'
        });
    }

    static async SetGlobalMultipliersAsync(multipliers)
    {
        return await ApiHelper.FetchJsonAndProcessErrorsAsync('api/server/admin-action/global-multipliers', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(multipliers)
        });
    }

    static async GetAllGroupsAsync()
    {
        const url = 'api/shop/admin-action/get-all-groups';

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'GET'
        });
    }

    static async GetAllProductsAsync()
    {
        const url = 'api/shop/admin-action/get-all-products';

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'GET'
        });
    }

    static async GetAllOrdersAsync()
    {
        const url = 'api/shop/admin-action/get-all-orders';

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'GET'
        });
    }

    static async SetOrderPaidAsync(orderId)
    {
        const params = new URLSearchParams({
            order_id: orderId
        });

        const url = `api/shop/admin-action/set-order-paid?${params.toString()}`;

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'POST'
        });
    }

    static async CreateShopTabAsync(tabId)
    {
        const params = new URLSearchParams({
            tab_id: tabId,
        });

        const url = `api/shop/admin-action/create-tab?${params.toString()}`;

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'POST'
        });
    }

    static async SetTabTitleAsync(tabId, title)
    {
        const params = new URLSearchParams({
            tab_id: tabId,
            title: title
        });

        const url = `api/shop/admin-action/set-tab-title?${params.toString()}`;

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'POST'
        });
    }

    static async DeleteTabAsync(tabId)
    {
        const params = new URLSearchParams({
            tab_id: tabId
        });

        const url = `api/shop/admin-action/delete-tab?${params.toString()}`;

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'DELETE'
        });
    }

    static async SetTabOrderAsync(tabId, order)
    {
        const params = new URLSearchParams({
            tab_id: tabId,
            order: order
        });

        const url = `api/shop/admin-action/set-tab-order?${params.toString()}`;

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'POST'
        });
    }

    static async SetTabGroupsAsync(tabId, groups)
    {
        const url = 'api/shop/admin-action/set-tab-groups';

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({tab_id: tabId, groups: groups})
        });
    }

    static async SetTabAvailableAsync(tabId, isAvailable)
    {
        const params = new URLSearchParams({
            tab_id: tabId,
            is_available: isAvailable
        });

        const url = `api/shop/admin-action/set-tab-available?${params.toString()}`;

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'POST'
        });
    }

    static async SetProductGroupsAsync(productId, groups)
    {
        const url = 'api/shop/admin-action/set-product-groups';

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({product_id: productId, groups: groups})
        });
    }

    static async SetProductOrderAsync(productId, order)
    {
        const params = new URLSearchParams({
            product_id: productId,
            order: order
        });

        const url = `api/shop/admin-action/set-product-order?${params.toString()}`;

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'POST'
        });
    }

    static async CreateShopGroupAsync(groupId)
    {
        const params = new URLSearchParams({
            group_id: groupId,
        });

        const url = `api/shop/admin-action/create-group?${params.toString()}`;

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'POST'
        });
    }

    static async SetGroupTitleAsync(groupId, title)
    {
        const params = new URLSearchParams({
            group_id: groupId,
            title: title
        });

        const url = `api/shop/admin-action/set-group-title?${params.toString()}`;

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'POST'
        });
    }

    static async SetGroupImageAsync(groupId, image)
    {
        const params = new URLSearchParams({
            group_id: groupId,
            image: image
        });

        const url = `api/shop/admin-action/set-group-image?${params.toString()}`;

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'POST'
        });
    }

    static async SetGroupOrder(groupId, order)
    {
        const params = new URLSearchParams({
            group_id: groupId,
            order: order
        });

        const url = `api/shop/admin-action/set-group-order?${params.toString()}`;

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'POST'
        });
    }

    static async DeleteGroupAsync(groupId)
    {
        const params = new URLSearchParams({
            group_id: groupId
        });

        const url = `api/shop/admin-action/delete-group?${params.toString()}`;

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'DELETE'
        });
    }

    static async CreateShopProductAsync(productId)
    {
        const params = new URLSearchParams({
            product_id: productId,
        });

        const url = `api/shop/admin-action/create-product?${params.toString()}`;

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'POST'
        });
    }

    static async SetProductTitleAsync(productId, title)
    {
        const params = new URLSearchParams({
            product_id: productId,
            title: title
        });

        const url = `api/shop/admin-action/set-product-title?${params.toString()}`;

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'POST'
        });
    }

    static async SetProductRewardStorageDataAsync(productId, data)
    {
        const params = new URLSearchParams({
            product_id: productId,
            data: data
        });

        const url = `api/shop/admin-action/set-product-reward-storage-data?${params.toString()}`;

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'POST'
        });
    }

    static async SetProductDescriptionAsync(productId, descriptionHtml)
    {
        const params = new URLSearchParams({
            product_id: productId
        });

        const url = `api/shop/admin-action/set-product-description?${params.toString()}`;

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({description_html: descriptionHtml})
        });
    }

    static async SetProductPriceAsync(productId, price)
    {
        const params = new URLSearchParams({
            product_id: productId,
            price_string: price
        });

        const url = `api/shop/admin-action/set-product-price?${params.toString()}`;

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'POST'
        });
    }

    static async SetProductAvailableAsync(productId, isAvailable)
    {
        const params = new URLSearchParams({
            product_id: productId,
            is_available: isAvailable
        });

        const url = `api/shop/admin-action/set-product-available?${params.toString()}`;

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'POST'
        });
    }

    static async SetProductShopImageAsync(productId, image)
    {
        const formData = new FormData();
        formData.append('image', image, 'image');

        const params = new URLSearchParams({
            product_id: productId
        });

        const url = `api/shop/admin-action/set-product-shop-image?${params.toString()}`;

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'POST',
            body: formData
        });
    }

    static async AddProductGalleryImageAsync(productId, image)
    {
        const formData = new FormData();
        formData.append('image', image, 'image');

        const params = new URLSearchParams({
            product_id: productId
        });

        const url = `api/shop/admin-action/add-product-gallery-image?${params.toString()}`;

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'POST',
            body: formData
        });
    }

    static async DeleteProductGalleryImageAsync(productId, imageId)
    {
        const params = new URLSearchParams({
            product_id: productId,
            image_id: imageId
        });

        const url = `api/shop/admin-action/delete-product-gallery-image?${params.toString()}`;

        return await ApiHelper.FetchJsonAndProcessErrorsAsync(url, {
            method: 'DELETE'
        });
    }
}